module.exports = __webpack_public_path__ + "img/ss1.537eb50a.png";